import { styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import { TextV2 } from '@insights-ltd/design-library/components';

type EventDetailsGridProps = {
  details: {
    dataTestId?: string;
    title: string;
    value: string;
  }[];
};

const EventDetailGridP = styled(TextV2)({
  textAlign: 'right',
  overflowWrap: 'anywhere',
  width: '100%',
  display: 'block',
});

const EventDetailGrid = ({ details }: EventDetailsGridProps) => {
  return (
    <>
      {details.map((detail) => (
        <Grid container key={detail.title}>
          <Grid size={6}>
            <TextV2
              {...(detail.dataTestId
                ? { 'data-testid': `event-detail-key-${detail.dataTestId}` }
                : {})}
              variant="bodyBold"
              color="textSecondary"
            >
              {detail.title}
            </TextV2>
          </Grid>
          <Grid size={6}>
            <EventDetailGridP
              {...(detail.dataTestId
                ? { 'data-testid': `event-detail-value-${detail.dataTestId}` }
                : {})}
              variant="bodyBold"
            >
              {detail.value}
            </EventDetailGridP>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default EventDetailGrid;
